export function formatNumber(locale: string, number: number, options?: Intl.NumberFormatOptions) {
	// Fix SSR mismatch error where numbers in Euskera or Galician are formatted in chrome with commas but in node are dots
	return new Intl.NumberFormat(locale === 'eu' || locale === 'gl' ? 'es' : locale, options).format(number);
}
